// @flow

const isPathOnlyUrl = (url: string) => !!url.match(/^\/[^/]/);

export default isPathOnlyUrl;
